import { useParams } from 'react-router';

/**
 * id проекта дашборда из роута /mws/projects/:id. Единый источник правды для
 * табов и провайдера недели — проект на странице фиксирован роутом, контекст
 * для него не нужен. NaN, если параметра нет (компонент вне маршрута проекта).
 */
export function useDashboardProjectId(): number {
  const { id } = useParams<{ id: string }>();
  return id ? Number(id) : NaN;
}
